import { render, staticRenderFns } from "./MovingKeys.vue?vue&type=template&id=a526dfae&scoped=true&"
import script from "./MovingKeys.vue?vue&type=script&lang=js&"
export * from "./MovingKeys.vue?vue&type=script&lang=js&"
import style0 from "./MovingKeys.vue?vue&type=style&index=0&id=a526dfae&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a526dfae",
  null
  
)

export default component.exports